import Helpers from '@helpers';
import * as React from 'react';
import { searchProduct } from './searchProduct';
import { payment } from './payment';
import { legal } from './legal';

class NewProductFactorController extends React.Component {
    constructor(props) {
        super(props);
    }

    public componentDidMount() {
        searchProduct();
        payment();
        legal();
        var stepControls = Array.from(document.getElementsByClassName('step-control'));
        var steps = Array.from(document.getElementsByClassName('step'));
        stepControls.forEach((value: HTMLElement) => {
            value.addEventListener('click',
                () => {
                    var step = value.parentElement;
                    if (step.classList.contains('collapse') &&
                        (step.classList.contains('completed') || step.classList.contains('active'))) {
                        steps.forEach((stepControl: HTMLElement) => {
                            stepControl.classList.add('collapse');
                        });
                        step.classList.remove('collapse');
                        var hiddenField = document.getElementById('ContentPlaceHolder1_hdnActiveStep') as HTMLInputElement;
                        hiddenField.value = step.getAttribute("id").replace("ContentPlaceHolder1_step_", "");
                    }
                });
        });
    }

    public render() {
        return null;
    }
}

Helpers.ReactHelper.createReactElement('NewProductFactorController', NewProductFactorController);
